export const euro = (value: number | null | undefined) => new Intl.NumberFormat('en-IE', { style: 'currency', currency: 'EUR' }).format(value ?? 0)
export const todayDublin = () => new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Dublin' }).format(new Date())
